<template>
  <div class="page">
    <el-form>
      <el-form-item label="">
        <el-input type="textarea" rows="5" style="width:100%;" v-model="content" placeholder="请输入"></el-input>
      </el-form-item>
      <p style="margin-bottom:15px;font-size: 14px;color:red;">填写后，商品开启为入户商品时，默认使用该模版内容进行用户提示</p>
      <el-form-item label="">
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  GetAllReseller
} from "../../api/api";
import weditor from "../../components/WangEditor";

export default {
  components: { weditor },
  data() {
    return {
      content: ''
    };
  },
  created() {
    GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then((res) => {
      if (res.data.success) {
        this.ResellerId = res.data.result.items[0].remoteKey;
        KSAXApiRequest({ path: 'Suppliers/GetInRoomNotice', parmsJson: {id: this.ResellerId} }).then(res => {
          if (res.data.success) {
            this.content = res.data.response.inRoomNotice
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    })
  },
  methods: {
    submit() {
      let data = {
        path: 'Suppliers/UpdateInRoomNotice',
        parmsJson: { id: this.ResellerId, inRoomNotice: this.content }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.$message.success('编辑成功')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
};
</script>

<style scoped></style>
